import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VoucherStatusEnum } from 'v3/shared/enums/voucher-status.enum';
import { voucherInitialState } from './state';
import { IVoucher } from './types';

export const voucherSlice = createSlice({
  name: 'voucher',
  initialState: voucherInitialState,
  reducers: {
    setVoucher: (state, action: PayloadAction<IVoucher>) => {
      state = action.payload;
      return state;
    },
    setVoucherStatus: (state, action: PayloadAction<VoucherStatusEnum>) => {
      state.status = action.payload;
      return state;
    },
    clearVoucherStatus: (state) => {
      state.status = voucherInitialState.status;
      return state;
    },
  },
});
